import { CharButton } from "../../ui/input/CharButton";
import { ComponentF, createElement } from "../../ui/ui";
import { getLog, getLogSize, lineCount } from "./logger";

export const LogContents: ComponentF<{ offset: number }> = (C, props) => {
  const entries = getLog();
  let logIndex = entries.length - 1 + props.offset;
  const top = C.bounds.y;
  let y = C.bounds.y + C.bounds.h;
  while (y > top && logIndex >= 0) {
    const lines = lineCount(entries[logIndex], C.bounds.w);
    y = y - lines;
    if (y >= top) {
      C.display.drawText(C.bounds.x, y, entries[logIndex], C.bounds.w);
      logIndex -= 1;
    }
  }
};

export const LogList: ComponentF<any> = (C) => {
  const [state, setState] = C.useState({ offset: 0 });

  const logSize = getLogSize();
  const canScrollUp =
    -1 * state.offset < logSize && C.bounds.h - 1 < logSize + state.offset;
  const canScrollDown = state.offset < 0;
  const scrollUp = () => {
    if (canScrollUp) {
      setState({ offset: state.offset - 1 });
    }
  };

  const scrollDown = () => {
    if (canScrollDown) {
      setState({ offset: state.offset + 1 });
    }
  };

  C.handlers.keypress = (key) => {
    if (key === "+" || key === "=") {
      scrollDown();
      return true;
    } else if (key === "-" || key === "_") {
      scrollUp();
      return true;
    }
    return false;
  };

  return [
    createElement(
      LogContents,
      {
        x: 0,
        y: 0,
        w: C.bounds.w - 2,
        h: C.bounds.h,
      },
      { offset: state.offset }
    ),
    createElement(
      CharButton,
      { x: C.bounds.w - 1, y: 0, w: 1, h: 1 },
      {
        disabled: !canScrollUp,
        title: "-",
        onClick: scrollUp,
      }
    ),
    createElement(
      CharButton,
      { x: C.bounds.w - 1, y: C.bounds.h - 1, w: 1, h: 1 },
      {
        disabled: !canScrollDown,
        title: "+",
        onClick: scrollDown,
      }
    ),
  ];
};
